<template>
  <div>
    <div class="tabs hide-small">
      <div :class="[ tab === 'main' ? 'active' : '' ]" @click="tab = 'main'">Main details</div>
    </div>
    <div class="tabs tabs-right hide-small">
      <div :class="[ isValid ? 'valid' : 'disabled', 'save-tab' ]" @click="save(false)">{{ saveOrUpdate }}</div>
      <div :class="[ isValid ? 'valid' : 'disabled', 'save-tab' ]" @click="save(true)">{{ saveOrUpdate }} &amp; exit</div>
    </div>
    <div class="dropdown show-small dropdown-admin-tabs">
      <button class="btn dropdown-toggle" type="button" data-toggle="dropdown">Options
        <span class="caret"></span></button>
      <ul class="dropdown-menu">
        <li @click="tab = 'main'">
          <a href="#">
            Main details
            <i class="fa fa-check-square-o" v-if="tab === 'main'"></i>
          </a>
        </li>
        <li :class="[ isValid ? 'valid' : 'disabled', 'save-dropdown' ]" @click="save(false)"><a href="#">{{ saveOrUpdate }}</a></li>
        <li :class="[ isValid ? 'valid' : 'disabled', 'save-dropdown' ]" @click="save(true)"><a href="#">{{ saveOrUpdate }} and exit</a></li>
      </ul>
    </div>
    <section id="main-content" class="clearfix">
      <div class="clearfix" slot="admin-content" id="location-content">
        <div class="col-xs-12 col-sm-6 main-location-details left top-small">
          <div class="form-group">
            <label for="cur-code" class="form-label">Code *</label>
            <input type="text" class="form-control" id="cur-code" v-model="entity.code"/>
          </div>
          <div class="form-group">
            <label for="cur-name" class="form-label">Name/Title *</label>
            <input type="text" class="form-control" id="cur-name" v-model="entity.name"/>
          </div>
        </div>
        <div class="col-xs-12 col-sm-6 main-location-details left bottom-small">
          <label for="cur-name" class="form-label">Category *</label>
          <select class="form-control" id="category" v-model="entity.category">
            <option value=""></option>
            <option v-for="(opt, i) in categories" :value="opt.code">{{ opt.name }}</option>
          </select>
        </div>
        <hr />
        <div class="col-xs-12">
          <div v-if="entity.category === 'QUOTE_EXTERNAL_LINK'">
            <div class="form-group">
              <label for="url" class="form-label">URL</label>
              <input type="text" class="form-control" id="url" v-model="entity.detail"/>
            </div>
          </div>
          <div v-else class="box">
            <div class="open box-body">
              <h4>Content Editor</h4>
              <ckeditor v-model="entity.detail" :config="config" :style="{ marginBottom: '10px' }"></ckeditor>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
  import AdminEntityMixin from '../../mixins/AdminEntityMixin'
  import HelperMixin from '../../mixins/Helpers'
  import Ckeditor from 'vue-ckeditor2'
  import ckconfig from '../../../helpers/ckeditorconfig'
  export default {
    name: 'Document',
    mixins: [ AdminEntityMixin, HelperMixin ],
    components: { Ckeditor },
    data () {
      return {
        newEntityScreen: 'Admin - Documents',
        editEntityScreen: 'Admin - Edit/View Document',
        tab: 'main',
        config: ckconfig,
        entity: {
          id: null,
          name: null,
          code: null,
          category: null,
          detail: null
        },
        boxes: [],
        entityName: 'document'
      }
    },
    computed: {
      isValid () {
        return this.entity.code && this.entity.name && this.entity.category &&
          this.entity.code.trim().length > 0 &&
          this.entity.name.trim().length > 0
      },
      categories () {
        return [
          { code: 'ADVISORY', name: 'Advisory' },
          { code: 'QUOTE_EXTERNAL_LINK', name: 'Quote External Link' }
        ]
      }
    },
    methods: {
      getBaseData () {
        return {
          id: null,
          name: null,
          code: null,
          category: null,
          detail: null
        }
      },
      preSaveRoutine () {
        if (this.entity.category === 'ADVISORY') {
          return this.$store.dispatch('library/clearAllUserAdvisorySetting')
        } else if (this.entity.category === 'QUOTE_EXTERNAL_LINK') {
          const length = this.entity.name ? this.entity.name.length : 0
          if (length > 40) {
            this.entity.name = this.entity.name.substring(0, 40) + '...'
          }
        }
        return new Promise((resolve) => { resolve() })
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/modules/admin/components/Document/Document.vue